module.exports = __webpack_public_path__ + "img/vk-icon.972a8665.svg";